import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import styles from '../styles/Guides.module.css';

const Guides = () => {
  return (
    <Container className={styles.container}>
      <Paper elevation={0} className={styles.section}>
        <Typography variant="h6" className={styles.title}>
          You can ask the AI assistant anything regarding wedding.
        </Typography>
      </Paper>

      <Paper elevation={0} className={styles.section}>
        <Typography variant="body1" className={styles.content}>
          For functionality demonstration purposes, the AI assistant can provide
          wedding dresses and bridal salons recommendations with images, whereas
          recommendations in other categories can only be in text form.
        </Typography>
      </Paper>

      <Paper elevation={0} className={styles.section}>
        <Typography variant="body1" className={styles.content}>
          When asking the AI assistant for wedding dress recommendations, you
          may be asked to upload your full-body photos to get better
          recommendations.
        </Typography>
      </Paper>

      <Paper elevation={0} className={styles.section}>
        <Typography variant="body1" className={styles.content}>
          You can ask the AI assistant to generate a checklist for you. You can
          also ask the AI assistant to update the checklist for you.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Guides;
